import { render, staticRenderFns } from "./WrongHomeDialog.vue?vue&type=template&id=06d31664&scoped=true"
import script from "./WrongHomeDialog.vue?vue&type=script&lang=ts"
export * from "./WrongHomeDialog.vue?vue&type=script&lang=ts"
import style0 from "./WrongHomeDialog.vue?vue&type=style&index=0&id=06d31664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06d31664",
  null
  
)

export default component.exports